export const STORIES_LIMIT = 12;

export const MAX_TOP_BANNERS = 2;
